import {UserApiCalls} from "../../apis/UserApiCalls";
import React, {useEffect, useState} from "react";
import {notifyError, notifySuccess, removePrefixNew} from "../../utils/helpers";
import {
    BANK_TITLE_TEXT,
    BUTTON,
    MODAL_CANCEL_TEXT, MODAL_SAVE_TEXT,
    QUES_BANK_CLOSE,
    QUESTION_BANK_MODAL,
    QUESTION_BANK_TEXT, SAVE_TO_QUE_BANK_DESC,
    SAVING_TEXT, SEARCH_TEXT, SELECT_A_QUESTION_BANK_TEXT, SAVE_TO_EXISTED_QUE_BANK_TEXT,
    TEXTBOX, SAVE_TO_NEW_QUE_BANK_TEXT, ENTER_QUE_BANK_NAME_PLACEHOLDER
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {YuJaRadioBox} from "../standardization/YuJaRadiobox";
import {YuJaDropdown} from "../standardization/YuJaDropdown";
import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {trimLineBreakerInQuestion, trimQuestion} from "../../utils/questionUtils";
import {SAVE_BANK_SUCCESS, UPDATE_BANK_SUCCESS} from "../../utils/toast-message-constants";
import classes from "../../pages/CreateQuizPage/ActivityEditor.module.css";


export default function SaveQuestionBankModal({setModalShow, show, selectedQuestion, pollKey}) {
    const { listQuestionProfiles, saveQuestionProfile, updateQuestionProfile } = UserApiCalls();

    const OPTIONS = {EXISTED: "EXISTED", NEW: "NEW"}
    const [dataLoading, setDataLoading] = useState(true);
    const [questionProfileData, setQuestionProfileData] = useState([]);
    const [selectedOpt, setSelectedOpt] = useState(OPTIONS.EXISTED);
    const [selectedId, setSelectedId] = useState("");
    const [newName, setNewName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const getQuestionProfiles = async () => {
        setDataLoading(true);
        listQuestionProfiles().then(res => {
            const sortedArray = Object.values(res)
                .sort((a, b) => {
                    let {index4Sk: timestampA} = a;
                    let {index4Sk: timestampB} = b;
                    timestampA = removePrefixNew(timestampA);
                    timestampB = removePrefixNew(timestampB);
                    return new Date(timestampA) - new Date(timestampB);
                });
            setQuestionProfileData(sortedArray);
        }).finally(() => {
            setDataLoading(false);
        });


    };

    const handleClose = () =>{
        resetStatus();
        setModalShow(false);
    };

    const resetStatus = () => {
        setQuestionProfileData([]);
        setDataLoading(true);
        setSelectedOpt(OPTIONS.EXISTED);
        setSelectedId("");
        setNewName("");
    }

    const isDisabled = () => {
        if (isSaving) {
            return true;
        }

        if (selectedOpt === OPTIONS.EXISTED) {
            return !selectedId;
        } else {
            return !newName;
        }

    }

    const handleSave = () => {
        const appendedQuestions = trimQuestion([{...selectedQuestion}]);
        for (const que of appendedQuestions) {
            trimLineBreakerInQuestion(que);
        }

        if (selectedOpt === OPTIONS.NEW) {
            if (!newName) {
                notifyError("Question bank name can not be empty.")
                return;
            }

            let pollToAdd = {
                questions: appendedQuestions,
                title: newName,
                pollKey: pollKey
            };
            setIsSaving(true);
            saveQuestionProfile(pollToAdd, true).then(() => {
                setModalShow(false);
                notifySuccess(SAVE_BANK_SUCCESS.replace(BANK_TITLE_TEXT, newName));
            }).finally(() => setIsSaving(false));

        } else {
            if (!selectedId) {
                notifyError("Please choose one question bank.")
                return;
            }
            let {questions=[], title} = questionProfileData.find(i => i.pk === selectedId);
            let pollToAdd = {
                questionProfileId: removePrefixNew(selectedId),
                title,
                questions: questions,
            };

            if (!!pollKey) {
                pollToAdd.pollKey = pollKey;
                pollToAdd.appendedQuestions = appendedQuestions;
            } else {
                const selectedQue = appendedQuestions[0];
                selectedQue.serialNo = pollToAdd.questions.length + 1;
                pollToAdd.questions.push(selectedQue);
            }



            setIsSaving(true);
            updateQuestionProfile(pollToAdd).then(() => {
                setModalShow(false);
                notifySuccess(UPDATE_BANK_SUCCESS.replace(BANK_TITLE_TEXT, title));
            }).finally(() => setIsSaving(false));
        }
    }


    useEffect(() => {
        if (show) {
            getQuestionProfiles();
        } else {
            resetStatus();
        }
    }, [show]);

    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"save-question-bank-modal"}
        >

            <ModalClose
                tabIndex={0}
                role={BUTTON}
                aria-label={QUES_BANK_CLOSE}
                onClick={handleClose}
                className="modal-close"
                style={{width: "24px", height: "24px"}}
            />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title tabIndex={0} role={TEXTBOX} aria-label={QUESTION_BANK_MODAL} className="modal-title" id="contained-modal-title-vcenter">
                    {"Save to " + QUESTION_BANK_TEXT}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, minHeight: 180}}>
                {dataLoading &&
                    <span style={{ width: "100%", height: 100}}>
                        <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                    </span>
                }

                {!dataLoading &&
                    <>
                        <span style={{color: "#6B6B6B", fontSize: 15, fontWeight: "400"}}>{SAVE_TO_QUE_BANK_DESC}</span>
                        <div style={{display: "flex", flexDirection: "column", gap: 15}}>
                            <div style={{display: "flex", alignItems: "center", gap: 25, flexWrap: "wrap"}}>
                                <YuJaRadioBox
                                    size={18}
                                    labelStyle={{fontSize: 15, fontWeight: "400", width: 250}}
                                    label={SAVE_TO_EXISTED_QUE_BANK_TEXT}
                                    checked={selectedOpt === OPTIONS.EXISTED}
                                    onClick={() => setSelectedOpt(OPTIONS.EXISTED)}
                                />
                                {selectedOpt === OPTIONS.EXISTED &&
                                    <YuJaDropdown
                                        containerStyle={{width: 250}}
                                        size={"small"}
                                        data={questionProfileData}
                                        value={selectedId}
                                        getOptionValue={i => i.pk}
                                        getOptionLabel={i => i.title}
                                        searchAble={true}
                                        placeholder={SELECT_A_QUESTION_BANK_TEXT}
                                        searchPlaceholder={SEARCH_TEXT}
                                        onChange={option => setSelectedId(option.pk)}
                                    />
                                }

                            </div>

                            <div style={{display: "flex", alignItems: "center", gap: 25, flexWrap: "wrap"}}>
                                <YuJaRadioBox
                                    size={18}
                                    labelStyle={{fontSize: 15, fontWeight: "400", width: 250}}
                                    label={SAVE_TO_NEW_QUE_BANK_TEXT}
                                    checked={selectedOpt === OPTIONS.NEW}
                                    onClick={() => setSelectedOpt(OPTIONS.NEW)}
                                />
                                {selectedOpt === OPTIONS.NEW &&
                                    <YuJaTextBox
                                        value={newName}
                                        containerStyle={{width: 250, height: 40, fontSize: 15}}
                                        onChange={e => setNewName(e.target.value)}
                                        placeholder={ENTER_QUE_BANK_NAME_PLACEHOLDER}
                                    />
                                }
                            </div>
                        </div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                    {!!dataLoading &&
                        <>
                            <span style={{width: 80, height: 35}}>
                                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                            </span>

                            <span style={{width: 80, height: 35}}>
                                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={4}/>
                            </span>
                        </>

                    }

                    {!dataLoading &&
                        <>
                            <span style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                                <YuJaButton
                                    onClick={handleClose}
                                    type={"secondary"}
                                    style={{width: 80, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                                >
                                   {MODAL_CANCEL_TEXT}
                                </YuJaButton>

                                <YuJaButton
                                    onClick={handleSave}
                                    disabled={isDisabled()}
                                    style={{width: 80, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                                >
                                   {isSaving
                                       ? <span className={classes.savingText}>{SAVING_TEXT}</span>
                                       : MODAL_SAVE_TEXT
                                   }
                                </YuJaButton>
                            </span>
                        </>
                    }
                </div>
            </Modal.Footer>

        </Modal>
    );
}